import React, { useState, useRef } from "react"
import { Link } from "gatsby"
import logo from "../content/assets/ukzn-logo.svg"
import Contents from "../pages/menu-content"
import {gsap} from 'gsap'

export default () => {
const [isMenuOpen, setIsMenuOpen] = useState(false);

let menuReveal = useRef(null);

const menuFunction = (e) => {
  e.preventDefault() // Operate the drop down
  !isMenuOpen ? setIsMenuOpen(true) : setIsMenuOpen(false)
  gsap.from(menuReveal, { xPercent: 100, opacity: 0, ease: 'Power3.easeOut', duration: .6 });
  gsap.to(menuReveal, { xPercent: 0, opacity: 1, ease: 'Power3.easeOut', duration: .6});
}

return (
  <>
    <div className="cf bg-orange-700 ls-md ">
            <div className="mw-1400 w-100 center items-center flex flex-column flex-row-m " >
                <div className="bg-white flex-start flex-center-m ph3 pv2 pv3-m ph3-m w-100 mw-300-m">
                  <img className="h6" src={logo} alt="..." />
                </div>
                <Link className="dib flex-center link" to="/" >
                <div className="pl3 pl4-s pv2 mw6">
                  <div className="f4 white-100 ttu mb1 ls-md">Teaching &amp; Learning <br/>REPORT 2019/20</div>
                  <div className="f7 white-100 ttu ls1 lh-copy mw-400">INSTITUTIONALISING THE SCHOLARSHIP OF TEACHING &amp; LEARNING</div>
                </div>
                </Link>
            </div>
      </div>

      <div className="w-100 bg-black sticky z-999">
        <div onClick={menuFunction}  className="mw-1400 center items-center flex flex-end white-100">

          <div className="list f6 fw7 white-100 pl3 flex items-center pv1 ls-md ttu pointer">
            <div>contents</div> 
            <div className="ml1 h2 w2">
            <svg fill="none" viewBox="0 0 24 24" stroke="currentColor" className="white-100 "><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" /></svg> 
            </div>
          </div>

        </div>
      </div>

      <div id="contentMenu" ref={el => {menuReveal = el}} className={ isMenuOpen ? "fixed z-9999 mw6 mw7-m right-0 top-0  min-vh-100 bg-white  bl b-black-10 shadow-5" : "dn" }>
        <div className="pa4 ph5-l vh-100 overflow-x-hidden overflow-y-auto momentum" onMouseUp={menuFunction} >
          <Contents />
        </div> 
      </div>
  </>
)
}